// extracted by mini-css-extract-plugin
export default {"container":"CustomerInfo_container__GLOG0"};